import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { EAssets } from "@rentiohq/web-shared-next/dist/assets";
import {
  Button,
  Icon,
  MainCard,
  Typography,
} from "@rentiohq/web-shared-next/dist/ui-components";
import { EButtonVariants } from "@rentiohq/web-shared-next/dist/utils/types/button";
import { useNavigate } from "react-router-dom";
import { PaymentSuccessStyles } from "./PaymentSuccess.styles";

export const PaymentSuccess = () => {
  const navigate = useNavigate();
  const sx = PaymentSuccessStyles();
  return (
    <MainCard contentSX={sx.wrapper}>
      <Icon
        path={EAssets.PaymentSuccess}
        realColor="#1AB394"
        width="188px"
        height="188px"
      />
      <Typography variant="h2" mt={12.5}>
        {getLocalizedText("tenant.payment.feedback.success.title")}
      </Typography>
      <Typography variant="body1" my={5} sx={sx.content.info}>
        {getLocalizedText("payment_detail.bank_wire.done.info")}
      </Typography>
      <Button
        variant={EButtonVariants.Contained}
        onClick={() => navigate("/payments")}
      >
        {getLocalizedText("system.close")}
      </Button>
    </MainCard>
  );
};
